import { PosItemDto } from './pos-item.dto';
import { IsString, IsUUID, IsInt, IsPositive } from 'class-validator';

export class PosItemToOrderDto {
	id: string;
	posItemId: string | null;
	orderId: string;
	quantity: number;
	itemPrice: number;
	itemName: string | null;
	createdAt?: Date;
	updatedAt?: Date;
	deletedAt?: Date | null;
	posItem?: PosItemDto;
}

export class BuyPosItemDto {
	@IsString()
	@IsUUID()
	public posItemId: string;

	@IsInt()
	@IsPositive()
	public quantity: number;
}